import { Theme, darken } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

interface ReactionStylesProps {
  isYours: boolean
}

const useStyles = makeStyles<Theme, ReactionStylesProps>(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: darken('#F7F8F9', 0.05),
    borderRadius: '0.5rem',
    padding: '0px 4px',
    lineHeight: 2,
    fontSize: theme.size.xs,
    '&:hover': {
      // todo: enable back when reactions removal is implemented
      //cursor: ({ isYours }) => (isYours ? 'pointer' : 'default'),
      outline: `1px solid  ${darken('#F7F8F9', 0.2)}`
    }
  },
  tooltipRoot: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    fontSize: theme.size.sm
  },
  count: {
    marginLeft: 2,
    fontSize: theme.size.xs
  }
}))

export default useStyles
